import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";

// Friendly page names for Meta Pixel (shows in Events Manager)
const PAGE_NAMES = {
  "/": "Home",
  "/registration/phoneNumber": "Registration - Phone",
  "/registration/otp": "Registration - OTP",
  "/registration": "Registration - User Details",
  "/registration/pending": "Registration - Pending",
  "/registration/rejected": "Registration - Rejected",
  "/selectMembership": "Select Membership",
  "/checkout": "Checkout",
  "/privacyPolicy": "Privacy Policy",
  "/useTerms": "Terms of Use",
  "/404": "Not Found",
  "/zh/registration/phoneNumber": "Registration (ZH) - Phone",
  "/zh/registration/otp": "Registration (ZH) - OTP",
  "/zh/registration": "Registration (ZH) - User Details",
  "/zh/registration/pending": "Registration (ZH) - Pending",
  "/zh/selectMembership": "Select Membership (ZH)",
};

/**
 * Fires Meta Pixel PageView on every route change so Facebook gets
 * the actual page path and name (SPA navigation doesn't reload the page).
 */
const MetaPixelPageView = () => {
  const location = useLocation();

  useEffect(() => {
    if (typeof window.fbq !== "function") return;

    const pagePath = location.pathname || "/";
    const pageTitle = PAGE_NAMES[pagePath] || pagePath;

    window.fbq("track", "PageView", {
      page_path: pagePath,
      page_title: pageTitle,
    });
  }, [location.pathname]);

  return null;
};

export default MetaPixelPageView;
